import { Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"
import { PricePerPersonPlaceholderModel } from "./pricePP"

export const CruiseDetailsPlaceholderModel = types.model("CruiseDetailsPlaceholder").props({
  id: types.string,
  name: types.string,
  lowestPrice: types.number,
  lowestPricePP: types.optional(PricePerPersonPlaceholderModel, {
    price: 0,
    adults: 0,
    children: 0,
  }),
  startDate: types.string,
  endDate: types.string,
  likes: types.array(types.string),
  lineLogo: types.string,
  lineName: types.string,
  imageUrl: types.string,
})

export type CruiseDetailsPlaceholder = Instance<typeof CruiseDetailsPlaceholderModel>
export type CruiseDetailsPlaceholderSnapshotOut = SnapshotOut<typeof CruiseDetailsPlaceholderModel>
export type CruiseDetailsPlaceholderSnapshotIn = SnapshotIn<typeof CruiseDetailsPlaceholderModel>
